import axios from "axios";
import { useEffect } from "react";
import { BASE_AUTH_URL, REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

export default function useTokenGeneration() {
  useEffect(() => {

  }, [])
  const generateToken = async () => {
    const jwtReponse = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}${BASE_AUTH_URL}/generate`)
    return jwtReponse.data;
  };

  const postOAuthToken = async (code, jwt) => {
    const formData = new URLSearchParams();
    const { REACT_APP_OAUTH_BASE_URL, REACT_APP_ASSERTION_TYPE } = process.env;
    formData.append('client_assertion', jwt);
    formData.append('client_assertion_type', REACT_APP_ASSERTION_TYPE);
    formData.append('code', code);
    formData.append('grant_type', 'authorization_code');

    return axios.post(`https://${REACT_APP_OAUTH_BASE_URL}/api/openid_connect/token`, formData.toString());
  }


  return {
    generateToken,
    postOAuthToken
  }
}
